import { Box, Stack, Button, Tooltip, Typography, Drawer, Autocomplete, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import {CommonGridToolBarWithExtraFilter, CommonPatientDetails } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { ImagePaths } from '../../../Utility/ImagePaths'
import { useHistory } from 'react-router-dom';
import { CheckAccessFunc, formatDateAndTimeMeth2 } from '../../../Components/CommonFunctions/CommonFunctions'

export default function RecheckRejectList() {
  const history = useHistory();
  const [page, setpage] = useState(0);
  const [pageSize, setpageSize] = useState(10);
  const [packageList, setPackageList] = useState([]);
  const [errorMsg, seterrorMsg] = useState(false);
  const [errorMsgText, seterrorMsgText] = useState('');
  const [successMsg, setsuccessMsg] = useState(false);
  const [successMsgText, setsuccessMsgText] = useState('');
  const [isloader, setisloader] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [selectedTestName, setselectedTestName] = useState(null);
  const [selectedType, setselectedType] = useState(null);
  const TestNameList = [{ head_name: 'Test 1' }, { head_name: 'Test 2' }, { head_name: 'Test 3' }]
  const TypeList = [{ name: 'Pending' }, { name: 'Completed' }]
  let commonDisable = CheckAccessFunc("front_office", "Settings", "Service Master Configuration", "Package Configuration", "SubTab")?.editAccess

  useEffect(() => {
    getPackageData()
  }, [])

  const errorMessage = (msg) => {
    seterrorMsgText(msg)
    seterrorMsg(true)
  }
  const successMessage = (msg) => {
    setsuccessMsgText(msg)
    setsuccessMsg(true)
  }

  const getPackageData = () => {
    try {
      setisloader(true)
      RestAPIService.getAll(Serviceurls.LAB_RESULT_HISTORY)
        .then((response) => {
          if (response.data.status === 'success') {
            setPackageList(response.data.data || [])
            setisloader(false)
          }
        }).catch(e => {
          setisloader(false)
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      setisloader(false)
      errorMessage(e.message)
    }
  }

  const tableView = () => {
    const gridToolBar = () => {
      return (
        <Box>
          <Box sx={{ position: 'absolute', left: '0', top: '0', display: 'flex', flexDirection: 'row', alignItems: 'center', mt: '0.15vw', ml: '0.25vw' }}>
            {/* <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Autocomplete
                options={TestNameList}
                clearIcon={false}
                value={selectedTestName}
                getOptionLabel={(option) => option?.head_name}
                sx={{ ml: '0.5vw' }}
                onChange={(event, value) => {

                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Department"
                    variant="outlined"
                    size="small"
                    sx={{ width: "15vw" }}
                  />
                )}
              />

              <Autocomplete
                options={TypeList}
                clearIcon={false}
                getOptionLabel={(option) => option?.name}
                sx={{ ml: '0.3vw' }}
                value={selectedType}
                onChange={(event, value) => {

                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Type"
                    variant="outlined"
                    size="small"
                    sx={{ width: "12vw" }}
                  />
                )}
              />
            </Box> */}
          </Box>
          <Box>
            <CommonGridToolBarWithExtraFilter />
          </Box>
        </Box>
      )
    }

    packageList?.forEach((element, index) => element.sno = index + 1)
    const columns = [
      {
        field: "patient_name", flex: 0.25, headerName: "Patient Details", headerAlign: "left", align: "left",
        renderCell: (params) => (<Box component={'div'}>
          <CommonPatientDetails disablePhoto={true} data={params?.row} hideInsurance={true} />
        </Box>),
        valueGetter: (params) => {
          const Name = params.row?.patient_name || "";
          const Mobile = params.row?.patient_mobile || "";
          const UHID = params.row?.patient_account_number || "";
          return `${Name} ${Mobile} ${UHID}`;
        }
      },
      {
        field: 'ip_op_number', headerName: 'IP / OP No | Bill No', flex: 0.20,
        valueGetter: (params) => params.row?.bill_no || params.row?.ip_op_number || '',
        renderCell: (params) => {
          let receiptDetails = params.row?.bill_no || params.row?.ip_op_number || '-';
          let receiptdate = params.row?.bill_date || params.row?.ip_op_datetime;
          return (
            <Box component={'div'} emed_tid='emed_lab_rcpt_dtls'>
              <Typography fontSize={'0.9vw'} fontWeight={600}>{receiptDetails ?
                receiptDetails?.length > 18 ?
                  <Tooltip placement='top' title={receiptDetails}><div style={{ fontSize: '0.9vw', fontWeight: 600 }}>{'...' + receiptDetails?.slice(-10)}</div></Tooltip> :
                  receiptDetails : '-'}</Typography>
              <Typography color={Colors.grayShade} fontSize={'0.8vw'}>{receiptdate ? formatDateAndTimeMeth2(receiptdate) : '-'}</Typography>
            </Box>
          )
        }
      },
      {
        field: 'depart_name', headerName: 'Department Name', flex: 0.15,
        renderCell: (params) => (params.row.depart_name ? params.row.depart_name?.length > 20 ?
          <Tooltip placement="top" title={params.row.depart_name}><Typography fontSize={'0.9vw'}>{params.row.depart_name?.slice(0, 20) + '...'}</Typography></Tooltip> :
          <Typography fontSize={'0.9vw'}>{params.row.depart_name}</Typography> : '-')
      },
      {
        field: 'status', headerName: 'Type', flex: 0.10, align: 'center', headerAlign: 'center',
        renderCell: (params) => (<Box component={'div'} sx={{ textTransform: 'capitalize' }}>{params?.row?.status ? params?.row?.status : '-'}</Box>)
      },
      {
        field: 'receipt_type', headerName: 'Group / Test', flex: 0.15,
        valueGetter: (params) => `${params.row?.test_name || ''} ${params.row?.group_name || ''}`,
        renderCell: (params) => {
          return (
            <Box component={'div'} emed_tid={'emed_lab_bill_type'}>
              <Typography fontSize={'0.9vw'} fontWeight={600}>{params?.row?.test_name || '-'}</Typography>
              <Typography fontSize={"0.8vw"} color={Colors?.grayShade}>{` group : ${params?.row?.group_name ? params?.row?.group_name : "-"}`}</Typography>
            </Box>
          )
        }
      },
      {
        field: 'verified_by', headerName: 'Verified By', flex: 0.15,
        renderCell: (params) => (params.row.verified_by ? params.row.verified_by?.length > 15 ?
          <Tooltip placement="top" title={params.row.verified_by}><Typography fontSize={'0.9vw'}>{params.row.verified_by?.slice(0, 15) + '...'}</Typography></Tooltip> :
          <Typography fontSize={'0.9vw'}>{params.row.verified_by}</Typography> : '-')
      },
      {
        field: 'reason', headerName: 'Reason', flex: 0.20,
        renderCell: (params) => (params.row.reason ? params.row.reason?.length > 20 ?
          <Tooltip placement="top" title={params.row.reason}><Typography fontSize={'0.9vw'}>{params.row.reason?.slice(0, 20) + '...'}</Typography></Tooltip> :
          <Typography fontSize={'0.9vw'}>{params.row.reason}</Typography> : '-')
      },
    ]
    return (
      <Box sx={{ height: '70vh', marginTop: '.5vw' }}>
        <DataGrid
          rows={packageList}
          columns={columns}
          getRowId={(row) => row['sno']}
          page={page}
          pageSize={pageSize}
          localeText={{
            toolbarColumns: "",
            toolbarDensity: "",
            toolbarExport: "",
            toolbarFilters: "",
            toolbarExportPrint: ""
          }}
          components={{
            Toolbar: gridToolBar,
            NoRowsOverlay: () => (
              <Box className='eMed_conf_nodata'>
                {'No Records To Be Shown'}
              </Box>
            )
          }}
          onPageChange={(newPage) => { setpage(newPage) }}
          onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
          rowsPerPageOptions={[10, 20, 30]}
          pagination
          headerHeight={40}
          disableSelectionOnClick
          loading={isloader}
        />
      </Box>
    )
  }

  const msgClose = () => {
    seterrorMsg(false);
    seterrorMsgText('');
    setsuccessMsg(false);
    setsuccessMsgText('');
  }

  return (
    <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
      <Box component={'div'} sx={{ height: '70vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white' }}>
        {tableView()}
      </Box>
      {errorMsg ?
        <ToastMsg
          severity={'error'}
          msg={errorMsgText}
          msgPop={msgClose}
        />
        : null}
      {successMsg ?
        <ToastMsg
          severity={'success'}
          msg={successMsgText}
          msgPop={msgClose}
        />
        : null}
    </Box>
  )
}
